import React from 'react';
import { useTranslation } from '@refinedev/core';
import { Button, Dropdown, Menu, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import i18n from '../../i18n';
import { DirectionType } from 'antd/es/config-provider/context';
import useLangStore from '../../core/lang';
import { EnglishFlag, EgyptFlag } from '../../Assets/Svgs';

export const LanguageSwitcher: React.FC = () => {
  const { changeLocale, getLocale } = useTranslation();
  const currentLocale = getLocale();
  const { setLocale } = useLangStore();
  const changeDirection = (lang: string) => {
    changeLocale(lang);
    setLocale(lang);
    const newDirection: DirectionType = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = newDirection;
    localStorage.setItem('direction', newDirection);
  };

  const menu = (
    <Menu selectedKeys={[currentLocale || '']}>
      {[...(i18n.languages || [])].sort().map((lang: string) => (
        <Menu.Item key={lang} onClick={() => changeDirection(lang)}>
          <Space>
            {lang === 'en' ? (
              <EnglishFlag width={16} height={16} />
            ) : (
              <EgyptFlag width={16} height={16} />
            )}
            {lang === 'en' ? ' English' : 'العربية'}
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <Button>
        <Space>
          {currentLocale === 'en' ? (
            <EnglishFlag width={16} height={16} />
          ) : (
            <EgyptFlag width={16} height={16} />
          )}
          {currentLocale === 'en' ? 'English' : 'العربية'}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
